import { css } from "@emotion/react";
import boxShadow from "assets/css/boxShadow";
import colors from "assets/css/colors";
import buttonCss from "assets/css/buttons/button.css";

export default [
  buttonCss,
  css`
    border: 2px solid ${colors.mainBlue};
    background-color: transparent;
    color: ${colors.mainBlue};
    &:active {
      border-color: ${colors.darkBlue};
      color: ${colors.darkBlue};
    }
    &:hover,
    &:active {
      background-color: transparent;
      box-shadow: ${boxShadow.blue};
    }
  `,
];
